import React from "react";
import { IconButton } from "../../controls/TooltipControls";
import { FormControl, InputGroup } from "react-bootstrap";
import { getSafe } from "../../util/storeHelper";
export default function EnvButton(props) {
    const { t, variable, open, onAdd, onOpen, onRemove } = props;
    const [varCopy, setVarCopy] = React.useState({ ...variable });
    React.useEffect(() => {
        setVarCopy({ ...variable });
    }, [variable]);
    const editKey = React.useCallback((evt) => {
        setVarCopy({ ...varCopy, key: evt.currentTarget.value });
    }, [varCopy]);
    const editValue = React.useCallback((evt) => {
        setVarCopy({ ...varCopy, value: evt.currentTarget.value });
    }, [varCopy]);
    const apply = React.useCallback(() => {
        if (variable !== undefined) {
            onRemove(variable.key);
        }
        if (varCopy.key !== undefined && varCopy.key.length > 0) {
            onAdd(varCopy.key, varCopy.value);
        }
        onOpen(undefined);
    }, [variable, varCopy, onAdd, onOpen, onRemove]);
    const openClick = React.useCallback(() => {
        onOpen(variable?.key !== undefined ? variable.key : "__add");
    }, [onOpen, variable]);
    const key = getSafe(varCopy, ["key"], "");
    const remove = React.useCallback(() => {
        onRemove(key);
    }, [onRemove, key]);
    if (open) {
        return (React.createElement(InputGroup, null,
            React.createElement(FormControl, { type: "text", value: key, onChange: editKey, placeholder: t("Key"), style: { width: "50%" } }),
            " ",
            React.createElement(FormControl, { type: "text", value: getSafe(varCopy, ["value"], ""), onChange: editValue, placeholder: t("Value"), style: { width: "50%" } }),
            React.createElement(InputGroup.Button, null,
                React.createElement(IconButton, { id: `btn-apply-${key}`, icon: "input-confirm", tooltip: t("Apply"), onClick: apply }))));
    }
    else {
        if (variable?.key === undefined) {
            return (React.createElement(IconButton, { id: "btn-add-env", icon: "add", tooltip: t("Add"), onClick: openClick }));
        }
        else {
            return (React.createElement("div", { className: "env-kvpair" },
                React.createElement("div", null,
                    React.createElement("b", null, varCopy.key),
                    " = ",
                    React.createElement("b", null, varCopy.value)),
                React.createElement("div", { className: "env-edit-buttons" },
                    React.createElement(IconButton, { id: `btn-edit-${varCopy.key}`, icon: "edit", tooltip: t("Edit"), onClick: openClick }),
                    React.createElement(IconButton, { id: `btn-remove-${varCopy.key}`, icon: "remove", tooltip: t("Remove"), onClick: remove }))));
        }
    }
}
